/** Contact placeholders (system). */
export const CONTACT_PLACEHOLDERS = [
  { key: 'wa_id', token: '{{contact.wa_id}}', label: 'Customer WhatsApp ID' },
  { key: 'name', token: '{{contact.name}}', label: 'Customer name' },
];

/**
 * System vars auto-populated by the engine (not user-defined). Resolved from the
 * captured date period (e.g. "Last Week") on integration.api nodes.
 */
export const SYSTEM_VARS = [
  { key: 'date_from', label: 'Date range start (system)' },
  { key: 'date_to', label: 'Date range end (system)' },
];

/**
 * Collect session var names from flow definition (Ask, Validate, Set var, save_from_api, list select).
 * @param {object} definition
 * @returns {string[]} unique var names
 */
export function collectFlowVarNames(definition) {
  const names = new Set();
  const nodes = definition?.nodes || [];

  nodes.forEach((node) => {
    const c = node?.config || {};
    const type = node?.type || '';

    if (c.var && typeof c.var === 'string') names.add(c.var);
    if (c.capture_var && typeof c.capture_var === 'string') names.add(c.capture_var);
    if (c.var_on_select) names.add(c.var_on_select);

    if (Array.isArray(c.buttons)) {
      c.buttons.forEach((btn) => {
        if (btn?.capture_var) names.add(btn.capture_var);
      });
    }

    if (type === 'integration.api' && c.save_from_api && typeof c.save_from_api === 'object') {
      Object.keys(c.save_from_api).forEach((k) => names.add(k));
    }
    if (c.use_token && typeof c.use_token === 'string') names.add(c.use_token);
    if (c.header_media_source === 'var' && c.header_media_value) names.add(c.header_media_value);

    if (type === 'ai.classify' && c.output_var) names.add(c.output_var);
    if (type === 'ai.extract' && Array.isArray(c.fields)) {
      c.fields.forEach((field) => {
        if (field?.name) names.add(field.name);
      });
    }
    if (type === 'ai.generate' && c.output_var && !c.send_inline) names.add(c.output_var);
    if (type === 'ai.reply' && c.knowledge_var) names.add(c.knowledge_var);
  });

  return Array.from(names).filter(Boolean).sort();
}

/**
 * Build placeholder tokens for chips: contact + {{vars.x}}.
 */
export function buildPlaceholderTokens(definition) {
  const tokens = CONTACT_PLACEHOLDERS.map((p) => p.token);
  SYSTEM_VARS.forEach((v) => tokens.push(`{{vars.${v.key}}}`));
  collectFlowVarNames(definition).forEach((name) => {
    tokens.push(`{{vars.${name}}}`);
  });
  return [...new Set(tokens)];
}

export function varNameToToken(name) {
  if (!name) return '';
  if (name.startsWith('{{')) return name;
  return `{{vars.${name}}}`;
}
